//en.js
const en = {
    main:'Index',
    mainNavigation: {
        title0:'Index',
        title1: 'About Us',
        title2:'Products and Pipeline',
        title3:'Research',
        title4:'News & Events',
        title5:'Contact Us'
    },
    viceNavigation:{
        navtit1:'Company Introduction',
        navtit2:'Founders',
        navtit3:'Company Team',
        navtit4:'Technological Innovation',
        navtit5:'Pipeline',
        navtit6:'Press Release',
        navtit7:'Industry Insights',
        navtit8:'Join Us',
    },
    company:{
        content1:'WestGene Biopharma Co., Ltd. was founded in July 2021 by Professor Yuquan Wei, academician of the Chinese Academy of Sciences and Professor Xiangrong Song, who has worked in R&D of mRNA therapeutics for more than 10 years. WestGene focuses on R&D of innovative mRNA drugs and adjuvants, and aims to becoming a global biopharma corporation integrating R&D, manufacturing and sales of mRNA drugs, who has core technology and independent intellectual property rights.',
        content2:'Through the collaboration with the National Key Laboratory of Biotherapy at Sichuan University, WestGene has built a professional core team involving multiple disciplines including biology, immunology, computer aided drug design (CADD), chemistry, nano-medicine, bioinformatics, pharmacy, toxicology, and clinical medicine. WestGene devotes itself to the comprehensive breakthrough in underlying technology of mRNA therapeutics with the help of the interdisciplinary collaborative team.',
        content3:`WestGene has achieved comprehensive breakthroughs on R&D of mRNA drugs, including the design of mRNA sequence core elements, targeting delivery systems and scale-up production. Currently, WestGene has owned more than 20 issued/pending patents worldwide,involving the innovative machine learning algorithm Smart5UTR, 5'-UTR, ionizable lipids, nanocarriers and intelligent manufacturing equipments.`,
        content4:`Based on a wealth of scientific research, WestGene has established a mature technology platform for mRNA therapeutics and a novel nano-adjuvant platform. The company has more than 20 pipelines that includes prophylactic vaccines against viruses, anti-cancer vaccines, anti-aging vaccines, anti-obesity vaccines, gene editing and novel nano-adjuvants. Among them, the novel nano-adjuvant has been approved with EUA and three class 1 mRNA drugs have entered clinical trials. WestGene's pipeline is strategically focused on mRNA-based vaccines for the treatment of cancer, with a diversified approach that includes short-, medium-, and long-term goals to facilitate agile progress. WestGene has strong development momentum and excellent risk resilience and is expected to achieve breakthrough growth in the near future.`,
        content6:'In the future, Westgene will make every effort to build a long downstream industrial chain and biomedical ecosystem. Westgene will become the enterprise with international competitiveness in mRNA drugs’ R&D to occupy the commanding heights of the mRNA industry.',
    },
    founderTit:'WestGene Biopharma Founder',
    manFounder:{
        name:'Dr. Yuquan Wei',
        tag1:'Academician of the Chinese Academy of Sciences',
        tag2:'Professor and Doctoral Supervisor at Sichuan University',
        des1:'Co-founder and Chairman of WestGene Biopharma Co., Ltd. Dr. Yuquan Wei is the Professor and Doctoral Supervisor at Sichuan University. He also serves as the Director of the Clinical Oncology Center at West China Hospital and the State Key Laboratory of Biotherapy, Chairman of the China Medicinal Biotechnology Association, Head of the National Biotherapy Collaborative Innovation Center. Dr. Yuquan Wei has previously held positions such as Vice President of Sichuan University, Vice President of the Chinese Medical Association, and Executive Deputy Director of the Biomedical Division of the Science and Technology Committee of the Ministry of Education. He is a co-editor of Signal Transduction and Targeted Therapy, associate editor of Human Gene Therapy, and associate editor of Current Molecular Medicine.',
        des2:'Dr. Yuquan Wei has long been engaged in the basic research, application development and clinical treatment of tumor biotherapy, and has made important contributions to the field. He has conducted in-depth research on the effects of stromal cells in the tumor microenvironment, including immune cells, fibroblasts and endothelial cells, and the regulatory effects of tumor cell metabolites on immune cells. He has achieved several innovative research results in the development and translational application of biotherapeutics such as gene drugs, vaccines, and small molecule targeted drugs. He has made remarkable achievements in industry-academic research collaboration and technology transfer. The patented products of biotherapeutics and small molecule targeted drugs developed by his team, which have independent intellectual property rights, have been successfully commercialized and approved for co-development by several domestic pharmaceutical companies. Dr. Yuquan Wei and his team have established an internationally advanced insect cell-based recombinant protein vaccine technology platform. They have developed two protein vaccines targeting XBB and other variants of the covid-19, which have been approved for Emergency Use Authorization (EUA).',
        
        
    },
    womenFounder:{
        name:'Dr. Xiangrong Song',
        tag1:'National-level Young Talent',
        tag2:'Professor and Doctoral Supervisor at Sichuan University ',
        tag3:'Ph.D. in Pharmacology ',
        tag4:'Postdoctoral training in Biology.',
        des1:'Co-Founder and General Manager. Dr. Xiangrong Song holds several positions and titles at the national and provincial levels, including committee member of the Nanobiotechnology Branch of the China Medicinal Biotechnology Association, committee member of the Nucleic Acid Vaccine Branch of the China Association for Vaccine, committee member of the Academic Committee of the Key Laboratory for Comprehensive Evaluation of Generic and New Drug and Pharmaceutical Excipient under the National Medical Products Administration, vice president of the Sichuan Association of Medical Communications, and more. She also serves as an editorial board member for six SCI journals, including Sig Transduct Target Ther (IF 38.104), Eur J Pharm Sci (IF 5.112) and Nat Rev Drug Discov (IF=64.797) Chinese edition, Acta Pharm Sin B (IF 14.903), Chin Chem Lett (IF 8.455), and Asian J Pharm Sci (IF 9.273).',
        des2:`Dr. Xiangrong Song has been involved in innovative drug development based on targeted delivery for more than 20 years. She has made extensive breakthroughs in the key technologies underlying mRNA drugs and holds core patents in mRNA sequence, delivery vectors and intelligent manufacturing devices. She has filed more than 60 patent applications (including 5 international patents) and has been granted more than 20 patents (including 1 U.S. patent). She has led more than 30 national and provincial research projects, including major projects funded by the National Science and Technology Major Project and the National Natural Science Foundation of China. She has published more than 100 SCI papers in prestigious journals such as Nature, Nat Comm, and Sci Adv, including more than 20 as first author or corresponding author, with an impact factor of more than 10. Under her leadership, three mRNA drug candidates have entered international clinical trials and a novel nanoadjuvant has been approved Emergency Use Authorization (EUA) in China.<br ><span style="text-indent: 2em;display:inline-block;">Dr. Xiangrong Song has received several prestigious national and provincial awards, including the Distinction Award at the National Disruptive Technology Innovation Competition(2022), the Gold Prize at the 1st West China Women's Science and Technology Innovation Competition(2023), the First Prize of the China Medical Association of Minorities Science and Technology Award (2019), and the Third Prize of the Chinese Medical Association Science and Technology Award (2020). Her rich practical experience in drug translation and development contributes to her achievements in the field.</span>`
    },
    
    newTechnology:{
        tit1:'Comprehensive breakthrough in underlying technology',
        title1:'Core intellectual property rights',
        message1:'The COVID-19 happened at the end of 2019, has greatly promoted the mRNA vaccines to enter the market. Global well-known pharmaceutical companies have scrambled to field products and patents in mRNA therapeutics.',
        message2:'At present, mRNA therapeutics are facing challenges in mRNA sequence optimization, targeting delivery system and large-scale manufacture and long-term storage. WestGene has got significant progress in the following aspects.',
        title2:'The core elements in mRNA sequence have important impact on expression of coded protein/peptide.',
        navdes2:'WestGene has built machine deep learning platform for mRNA sequence design optimization to improve the coded protein expression or antigen presentation.',
        title3:'The ionizable lipids, the key excipient of LNP, have great influence on the biodistribution and storage stability. ',
        navdes3:'WestGene has developed many novel ionizable lipids with independent intellectual property right through structure design directed by AI model, and broken through the technical patent barrier of mRNA delivery.',
        title4:' The formulation of mRNA drug preparation has remarkable effect on efficacy, safety and storage stability.',
        navdes4:'WestGene has built mRNA drug preparation platform for targeting delivery of mRNA to specific organ or cell (lung, spleen). The center combination design was developed to optimize the formula of mRNA drugs in vivo, and the novel anionic nano-carrier (ANC) was constructed for the first time.',
        title5:'The transformation research is also challenging for the development of innovative mRNA drugs. ',
        navdes5:'Westgene has established a set of evaluation protocols for the efficacy and safety of mRNA innovative drugs, which provided a good technical platform for the clinical transformation of mRNA drugs.',
        message3:'Up to now, WestGene has applied for several international patents with independent intellectual property in mRNA sequence desine, delivery system and large-scale manufacture. Based on these core technologies, WestGene developed SARS-CoV-2 variants mRNA vaccine against Delta and Omicron variants with good safety and immunogenicity.',
        message4:'WestGene has developed nearly 20 pipelines including infectious disease, oncology, aging, obesity, gene editing and novel adjuvant and all-round fielded products in mRNA drugs track. Simultaneously, successful development of novel adjuvants including WGa-01, broke the limit of only aluminum adjuvant available. The neutralizing antibody induced by the vaccines under the synergism of WGa-01, is 10-100 times higher than that of the traditional aluminum adjuvant.'

    },
    lineList:{
        tag1:'Infectious Diseases',
        tag2:'Anti-tumor Immunotherapy',
        tag3:'Gene Editing Treatment',
        tag4:'Protein Replacement Therapeutics',
        tag5:'Adjuvant',
        msg1:`The Company's product pipeline includes more than 20 mRNA therapeutics and vaccine adjuvants, including prophylactic vaccines against viruses, anti-cancer vaccines, anti-aging vaccines, anti-obesity vaccines, gene editing and novel nano-adjuvants.`
    },
    publication:{
        more:'Read more'
    },
    coutactList:{
        title1:'Address',
        area:"No.552 Fenghuang Road,",
        city:"Chengdu Tianfu International Bio-Town,",
        Address:"Chengdu, Sichuan, P.R. China",
        title2:'Telephone',
        title3:'E-mail',
        title4:'Contact Us',


        peopleNmae1:'Business Development ',
        tel1:'Tel:  Mr. Yang+(86) 17311313455 ',
        peopleMail1:"E-mail: yangyang@westgenepharma.com ",
        peopleNmae2:'Investor Relations',
        tel2:'Tel: Mr. Zhang +(86) 18628152521',
        peopleMail2:"E-mail: zhangjinjin@westgenepharma.com",
        peopleNmae3:'Careers',
        tel3:'Tel:Mr. Guo +(86) 13666164764',
        peopleMail3:"E-mail: guoyusheng@westgenepharma.com",

        peopleNmae4:'Procurement & Supplier Partnerships',
        tel4:'Tel:  Mr. Zhong +(86) 19822928200',
        peopleMail4:"E-mail:zhonghaijie@westgenepharma.com",
    },
    swiperText:'We focus on developing more effective ',
    swiperText1:'drugs and treatments for various diseases',
    apply:{
        title:"Core Products",
        text1:"We have developed more than 20 kinds of product pipeline in mRNA drug and adjuvant,",
        text2:'such as mRNA vaccines against infectious diseases, tumor, obesity, etc.'
    },
    applyIcon:{
        title1:'Infectious Diseases',
        title2:"Anti-tumor Immunotherapy",
        title3:'Gene Editing Treatment',
        title4:'Protein Replacement Therapy',
        title5:'Adjuvant'
    },
    companytwo:{
        title1:'About WestGene',
        title2:'WestGene Biopharma',
        message:'WestGene Biopharma Co., Ltd. was founded in July 2021 by Professor Wei Yuquan, academician of the Chinese Academy of Sciences and Professor XiangRong Song, who has worked in mRNA drugs research and development for more than 10 years. WestGene focus on the research and development of innovative mRNA drugs and adjuvants, and aims to becoming a global biopharma corporation integrating R&D, manufacturing and sales of mRNA drugs, who has core technology and independent intellectual property rights.',
        more:'ReadMore'
    },
    newsList:{
        title1:'Technological Innovation',
        message:'Supported by State/National Key Laboratory of Biotherapy of Sichuan University.<br> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;WestGene has built a professional core team composed of experts and professors, whose research field include biology, immunology, computer aided drug design (CADD), synthetic chemistry, nano-medicine, bioinformatics, pharmacology, toxicology, and clinical medicine. Through the establishment of an interdisciplinary collaborative innovation model, WestGene has made many technological breakthroughs on mRNA design, delivery and medicine translation.'
    },
    newstitle:'Newsroom',
    nunberList:{
        msg:" Westgene is committed to be an international company with core technology and independent intellectual property rights in the R&D and manufacturing filed of mRNA drugs and adjuvants.",
        text1:'Clinical Products',
        text2:'Development Products',
        text3:'Scientific researcher'
    },
    news:{
        title1:'News & Events',
        title2:'Industry Information'
    },
    processPop1:'Launched under EUA in 2023',
    // processPop1:'1、Two types of vaccine granted EUA in China, one <br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; nearing Phase 3 completion for commercialization',
    // processPop2:'2、WHO PQ certification pending',
    processPop3: 'Phase I ongoing; Phase II planned in 2026',
    processPop4: 'US/CN IND cleared in 2025',
    processPop5: '',
    processPop6: '',
    processPop7: 'Phase II Approved in 2023',
    processPop8: 'IIT ongoing',


    companyName:'',
    changeLineName:{
        title1:'Infectious <br> Diseases',
        num1:'',
        title2:"Anti-tumor<br> Immunotherapy",
        num2:'',
        title3:'Gene Editing <br> Treatment',
        num3:'',
        title4:'Protein Replacement <br> Therapy',
        num4:'',
        title5:'Adjuvant',
        num5:''
    },
    pipelineVaccin1:{
        name1:'COVID-19 Vaccine',
        name2:'Malaria Vaccine',
        name3:'DENV Vaccine',
        name4:'RSV Vaccine'
    },
    pipelineVaccin2:{
        name1:'EBV Positive Cancer Vaccine',
        name2:'Hepatic Carcinoma Vaccine',
        name3:'Gastric Cancer Vaccine',
        name4:'Ovarian Cancer Vaccine',
        name5:'Breast Cancer Vaccine',
        name6:'Pancreatic Cancer Vaccine 1 ',
        name7:'Pancreatic Cancer Vaccine 2',
    },
    pipelineVaccin3:{
        name1:'Hepatocytes Targeted Gene Editing',
        name2:'Alveolar Cells Targeted Gene Editing',
        name3:'Splenocytes Targeted Gene Editing',
    },
    pipelineVaccin4:{
        name1:'Cancer',
        name2:'COVID',
        name3:'Obesity',
        name4:'Aging'
    },
    pipelineVaccin5:{
        name1:'Novel Intramuscular',
        name2:'Adjuvant',
        name3:'Novel Nasal Adjuvant',
        progress:'Clinical trials were conducted<br>  in China and Mexico.'
    },
    pipelineProgress:{
        title1:'Discovery',
        title2:'Preclinical Development',
        title3:'IND',
        title4:'Phase 1',
        title5:'Phase 2',
        title6:'Phase 3',
        title7:'EUA',
    },
    pipelineTable:{
        header:{
            platform:'R&D Platform',
            code:'Product Code',
            target:'Target / Indication',
            preclinical:'Preclinical',
            ind:'IND',
            phase1:'IIT / Phase I',
            phase2:'Phase II',
            phase3:'Phase III',
            launch:'Launch',
            partner:'Notes / Partners',
        },
        platforms:[
            {
                name:'Universal Therapeutic<br>Tumor Vaccines',
                products:[
                    {
                        code:'WGc-043',
                        target:'EBV+ Tumors',
                        progressStart:0,
                        progressEnd:3.5,
                        progressText:'CN/US IND in 2024, Phase II in 2026',
                        barType:'green',
                        barOutline:false,
                        showArrow:true,
                        stageLabels:[],
                        launchNote:'',
                        partnerTag:'FIC',
                        partnerName:'',
                    },
                    {
                        code:'WGc-0201',
                        target:'HBV+ Liver Cancer',
                        progressStart:0,
                        progressEnd:1,
                        progressText:'CN/US IND in 2025',
                        barType:'green',
                        barOutline:false,
                        showArrow:true,
                        stageLabels:[],
                        launchNote:'',
                        partnerTag:'FIC',
                        partnerName:'',
                    },
                ],
            },
            {
                name:'In vivo<br>CAR-T',
                products:[
                    {
                        code:'WGb-0301',
                        target:'CD19 Tumor / Autoimmune',
                        progressStart:0,
                        progressEnd:1,
                        progressText:'',
                        barType:'blue',
                        barOutline:true,
                        showArrow:true,
                        stageLabels:[{ col:2, text:'IIT', blue:true }],
                        launchNote:'',
                        partnerTag:'BIC',
                        partnerName:'',
                    },
                    {
                        code:'WGb-0302 / WGb-0305',
                        target:'BCMA Autoimmune',
                        progressStart:0,
                        progressEnd:1,
                        progressText:'',
                        barType:'blue',
                        barOutline:true,
                        showArrow:true,
                        stageLabels:[{ col:2, text:'IIT', blue:true }],
                        launchNote:'',
                        partnerTag:'BIC',
                        partnerName:'Cartesian Therapeutics',
                    },
                    {
                        code:'WGb-0304',
                        target:'BCMA/CD19 Autoimmune',
                        progressStart:0,
                        progressEnd:1,
                        progressText:'',
                        barType:'blue',
                        barOutline:true,
                        showArrow:true,
                        stageLabels:[{ col:2, text:'IIT Filing', blue:true }],
                        launchNote:'',
                        partnerTag:'BIC',
                        partnerName:'',
                    },
                ],
            },
            {
                name:'Protein<br>Replacement',
                products:[
                    {
                        code:'WGr-03',
                        target:'Blood Diseases',
                        progressStart:0,
                        progressEnd:1,
                        progressText:'Co-development',
                        barType:'light-blue',
                        barOutline:false,
                        showArrow:true,
                        stageLabels:[],
                        launchNote:'',
                        partnerTag:'FIC',
                        partnerName:'KONRUNS',
                    },
                    {
                        code:'WGb-02',
                        target:'TCE',
                        progressStart:0,
                        progressEnd:1,
                        progressText:'',
                        barType:'blue',
                        barOutline:true,
                        showArrow:true,
                        stageLabels:[],
                        launchNote:'',
                        partnerTag:'',
                        partnerName:'',
                    },
                ],
            },
            {
                name:'Preventive<br>Vaccines',
                products:[
                    {
                        code:'WGe-0102',
                        target:'Preventive Vaccine',
                        progressStart:0,
                        progressEnd:2,
                        progressText:'LNP Out-licensing',
                        barType:'blue',
                        barOutline:false,
                        showArrow:true,
                        stageLabels:[],
                        launchNote:'',
                        partnerTag:'Undisclosed',
                        partnerName:'BGI',
                    },
                    {
                        code:'WGv-0129',
                        target:'COVID-19 Vaccine',
                        progressStart:0,
                        progressEnd:4,
                        progressText:'Phase II in 2023',
                        barType:'blue',
                        barOutline:false,
                        showArrow:true,
                        stageLabels:[],
                        launchNote:'',
                        partnerTag:'Inactive',
                        partnerName:'',
                    },
                ],
            },
            {
                name:'Novel Nano<br>Adjuvants',
                products:[
                    {
                        code:'WGa-01',
                        target:'COVID / Flu Vaccine',
                        progressStart:0,
                        progressEnd:6,
                        progressText:'Adjuvant Out-licensing&nbsp;&nbsp;EUA in 2023',
                        barType:'blue',
                        barOutline:false,
                        showArrow:false,
                        stageLabels:[],
                        launchNote:'',
                        partnerTag:'BIC',
                        partnerName:'WESTVAC',
                    },
                ],
            },
        ],
    },

    addCompany:{
        tit1:'',
        text1:'To Be a Respectful Company of Unlimited Innovation.  ',
        tit2:'',
        text2:'Nurturing Hope, Easing Suffering, Creating Healthier Futures for Every Individual.',
        tit3:'',
        text3:'Science、Innovation<br>Collaboration、Quality'
    },
    page:{
        title:"WestGene to Advance Clinical Trials Following Dual IND Approvals for World’s First EB Virus-Related mRNA Therapeutic Cancer Vaccine",
        time:' August 8, 2024',
        text1:'WestGene Biopharma is proud to announce that its mRNA therapeutic cancer vaccine, WGc-043, has received dual IND approvals from China’s National Medical Products Administration (NMPA) and the US FDA. This unprecedented achievement marks the world’s first IND-approved mRNA vaccine for EBV-related cancers in both the United States and China.',
        text2:'',
        title1:'Groundbreaking milestone in cancer immunotherapy',
        text3:'On 6 August, the Center for Drug Evaluation (CDE) of the NMPA approved the clinical trial application for WGc-043 injection, allowing the initiation of Phase I clinical trials. This dual approval further validates WestGene’s expertise in core mRNA technologies such as delivery vectors and sequence design, and accelerates the commercialisation of effective and low-toxicity anti-tumour mRNA vaccines worldwide.',
        title2:'Revolutionary technology',
        text4:'WGc-043 is part of WestGene’s portfolio of more than 20 mRNA vaccine candidates. The innovative aspects of WGc-043 include',
        text5:'1. AI-assisted antigen screening: The use of AI to select the broadest and safest protein sequences with the introduction of a globally unique immuno-enhancer (IE) into the mRNA molecule. This design activates the patient’s anti-tumour immunity, generating cytotoxic T-cells (CTLs), antigen-specific antibodies and memory T-cells, providing highly effective anti-cancer effects comparable to combined CAR-T and monoclonal antibody therapies, and preventing tumour recurrence.',
        text6:'2. Advanced delivery system: The newly developed LNP delivery system, patented in China, the US, Europe, Canada, Australia and South Africa, has demonstrated safety and delivery efficiency in clinical trials of three of WestGene’s proprietary products.',
        title3:'Significant market potential and Innovative immunotherapy for EBV-related cancers',
        text7:'The EBV, classified as a Group 1 carcinogen by the International Agency for Research on Cancer (IARC), infects more than 90% of the world’s population and is associated with more than ten malignancies, including nasopharyngeal carcinoma, lymphoma, gastric cancer, lung cancer, liver cancer, esophageal cancer, breast cancer and cervical cancer. WGc-043 is now approved in both countries for treating EBV-positive solid tumors and hematologic malignancies. This new immunotherapy option, backed by high-quality preliminary data, is expected to demonstrate excellent safety and anti-tumor activity in upcoming clinical trials.',
        title4:'WGc-043 has completed investigator-initiated trials (IITs) in nasopharyngeal carcinoma and natural killer T-cell lymphoma, demonstrating superior safety and efficacy compared to existing mRNA cancer vaccines. Its launch is expected to be a major breakthrough in mRNA immunotherapy for EBV-positive tumours.',
        text8:'Comprehensive pipeline and commercialisation progress',
        text9:'Building on its scientific achievements, WestGene has established five R&D platforms. WestGene’s pipeline includes more than 20 products, including mRNA cancer vaccines, mRNA preventive vaccines for infectious diseases, and therapeutic drugs for conditions such as obesity and ageing. In addition to the IND approval for its cancer product, WestGene’s novel nano-adjuvant WGa01 received EUA in China last year, marking a significant milestone in domestic production.',
        title5:'As WestGene moves forward, its pioneering spirit and commitment to innovation promise to revolutionise the field of mRNA technology and cancer therapy. WestGene is currently open to various forms of commercial collaboration, including but not limited to pipeline licensing, co-development and technology licensing.',
        text10:'View original content to download multimedia: https://www.prnewswire.com/news-releases/westgene-to-advance-clinical-trials-following-dual-ind-approvals-for-worlds-first-eb-virus-related-mrna-therapeutic-cancer-vaccine-302217411.html',
        text11:'',
      
        

        
    } ,
    page2:{
        title:'WestGene leads the way in mRNA innovation at the 4th mRNA Therapeutics Summit',
        time:'News provided by WestGene Aug 01, 2024, 21:59 ET',
        text1:``,
        text2:`July 29-31 - The 4th mRNA Therapeutics Summit, one of the most important conferences in the global mRNA industry, took place in Boston, USA. Over 400 industry experts and 65 leading researchers in mRNA development gathered to discuss the latest breakthroughs and expanding applications of mRNA technology. Dr Xiangrong Song, co-founder of Chengdu-based WestGene Biopharma, was invited to attend and share insights into WestGene's pioneering work in mRNA therapeutics, with a particular focus on the world's leading EBV-related cancer mRNA therapeutic vaccine, WGc-043.`,
        text3:'Highlighting breakthroughs in mRNA therapeutics',
        text4:`Dr. Song presented the latest research data and technological advancements of WGc-043, the first mRNA therapeutic vaccine targeting EBV-related tumors to achieve IND milestones in both China and the US. In her keynote presentation, Dr. Song detailed the development of WGc-043, highlighting its safety and efficacy in the treatment of NKT cell lymphoma (NKTCL) and nasopharyngeal carcinoma (NPC). The vaccine utilizes WestGene's breakthrough technologies in mRNA sequence design, novel delivery vectors and scalable manufacturing to ensure high standards of safety and efficacy.`,
        text5:`During the Summit, Dr Song also discussed the broader challenges and opportunities within the mRNA industry, in particular the need to improve protein expression and delivery system efficiency while reducing production costs. She emphasized the importance of balancing efficacy and safety, a principle that has guided WestGene's R&D efforts from the outset. Dr. Song also highlighted WestGene's collaborative approach, which includes pipeline licensing for access to validated candidates, co-development projects that leverage combined expertise, and technology licensing to enable partners to use WestGene's cutting-edge solutions in their own developments, thus accelerating innovation and therapeutic advancements.`,
        text6:'',
        text7:`The Summit featured in-depth discussions on the latest clinical data, platform development, regulatory insights, and frontier applications of mRNA therapeutics to address various indications, including oncological, rare, and infectious diseases.`,
        text8:'',
        text9:`Dr. Song concluded, "Presenting our research at such platform is very meaningful. mRNA technology offers new hope and options for the treatment of malignancies, and our studies underscore the immense potential of this therapy in terms of safety and efficacy.`,
        text10:`WestGene Biopharma remains committed to pushing the boundaries of mRNA therapeutics, leveraging its proprietary technologies and collaborative framework to bring transformative therapies to patients worldwide.`,
        text11:'',
        text12:'',
        tage1:'',
        tage2:'General Manager Dr Xiangrong Song, General Manager & co-founder of Chengdu-based WestGene Biopharma'

    }
}
export default en;



// WEBPACK FOOTER //
// ./src/i18n/config/en.js